import { useState, useEffect } from "react";

const API = "https://scraps-backend.onrender.com";
const FONT = `@import url('https://fonts.googleapis.com/css2?family=Barlow+Condensed:wght@700;800&family=Inter:wght@400;500;600;700&display=swap');`;
const CSS = `
  * { box-sizing: border-box; margin: 0; padding: 0; }
  body { font-family: 'Inter', sans-serif; background: #0a0e1a; color: #f0f4ff; }
  @keyframes fadeIn { from { opacity:0; transform:translateY(6px); } to { opacity:1; transform:translateY(0); } }
  @keyframes pulse { 0%,100% { opacity:1; } 50% { opacity:0.4; } }
  @keyframes popIn { from { opacity:0; transform:scale(0.95); } to { opacity:1; transform:scale(1); } }
  .team-card:hover { border-color: #3d9e7a !important; background-color: #f0fdf8 !important; transform: translateY(-1px); }
  .team-card { transition: all 0.12s; }
  ::-webkit-scrollbar { width: 4px; height: 4px; }
  ::-webkit-scrollbar-track { background: transparent; }
  ::-webkit-scrollbar-thumb { background: rgba(255,255,255,0.1); border-radius: 4px; }
`;

const NFL_TEAMS = [
  { name:"Arizona Cardinals",     abbrev:"ari", short:"ARI" },
  { name:"Atlanta Falcons",       abbrev:"atl", short:"ATL" },
  { name:"Baltimore Ravens",      abbrev:"bal", short:"BAL" },
  { name:"Buffalo Bills",         abbrev:"buf", short:"BUF" },
  { name:"Carolina Panthers",     abbrev:"car", short:"CAR" },
  { name:"Chicago Bears",         abbrev:"chi", short:"CHI" },
  { name:"Cincinnati Bengals",    abbrev:"cin", short:"CIN" },
  { name:"Cleveland Browns",      abbrev:"cle", short:"CLE" },
  { name:"Dallas Cowboys",        abbrev:"dal", short:"DAL" },
  { name:"Denver Broncos",        abbrev:"den", short:"DEN" },
  { name:"Detroit Lions",         abbrev:"det", short:"DET" },
  { name:"Green Bay Packers",     abbrev:"gb",  short:"GB"  },
  { name:"Houston Texans",        abbrev:"hou", short:"HOU" },
  { name:"Indianapolis Colts",    abbrev:"ind", short:"IND" },
  { name:"Jacksonville Jaguars",  abbrev:"jax", short:"JAX" },
  { name:"Kansas City Chiefs",    abbrev:"kc",  short:"KC"  },
  { name:"Las Vegas Raiders",     abbrev:"lv",  short:"LV"  },
  { name:"Los Angeles Chargers",  abbrev:"lac", short:"LAC" },
  { name:"Los Angeles Rams",      abbrev:"lar", short:"LAR" },
  { name:"Miami Dolphins",        abbrev:"mia", short:"MIA" },
  { name:"Minnesota Vikings",     abbrev:"min", short:"MIN" },
  { name:"New England Patriots",  abbrev:"ne",  short:"NE"  },
  { name:"New Orleans Saints",    abbrev:"no",  short:"NO"  },
  { name:"New York Giants",       abbrev:"nyg", short:"NYG" },
  { name:"New York Jets",         abbrev:"nyj", short:"NYJ" },
  { name:"Philadelphia Eagles",   abbrev:"phi", short:"PHI" },
  { name:"Pittsburgh Steelers",   abbrev:"pit", short:"PIT" },
  { name:"San Francisco 49ers",   abbrev:"sf",  short:"SF"  },
  { name:"Seattle Seahawks",      abbrev:"sea", short:"SEA" },
  { name:"Tampa Bay Buccaneers",  abbrev:"tb",  short:"TB"  },
  { name:"Tennessee Titans",      abbrev:"ten", short:"TEN" },
  { name:"Washington Commanders", abbrev:"wsh", short:"WSH" },
];

const getTeam = (name) => NFL_TEAMS.find(t => t.name.toLowerCase() === name?.toLowerCase());

const formatGameTime = (commenceTime) => {
  if (!commenceTime) return null;
  try {
    const date = new Date(commenceTime);
    return date.toLocaleString("en-US", {
      timeZone: "America/New_York",
      weekday: "short",
      month: "numeric",
      day: "numeric",
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    }).replace(",", "") + " ET";
  } catch(e) { return null; }
};

const isGameLocked = (commenceTime) => {
  if (!commenceTime) return false;
  return new Date() >= new Date(commenceTime);
};
const getLogo = (name) => { const t = getTeam(name); return t ? `https://a.espncdn.com/i/teamlogos/nfl/500/${t.abbrev}.png` : null; };
const getShort = (name) => { const t = getTeam(name); return t ? t.short : name?.slice(0,3).toUpperCase(); };

function TeamLogo({ name, size = 40, style = {} }) {
  const logo = getLogo(name);
  const [err, setErr] = useState(false);
  if (!logo || err) return (
    <div style={{ width:size, height:size, borderRadius:"50%", backgroundColor:"#e5e7eb", display:"flex", alignItems:"center", justifyContent:"center", fontSize:size*0.28, fontWeight:700, color:"#6b7280", flexShrink:0, ...style }}>
      {getShort(name)}
    </div>
  );
  return <img src={logo} alt={name} width={size} height={size} onError={()=>setErr(true)} style={{ objectFit:"contain", flexShrink:0, ...style }} />;
}

function ConfirmPickModal({ team, week, opponent, spread, onConfirm, onCancel, submitting }) {
  const spreadVal = spread !== undefined ? (spread > 0 ? `+${spread}` : `${spread}`) : null;
  return (
    <div onClick={onCancel} style={{ position:"fixed", inset:0, backgroundColor:"rgba(0,0,0,0.6)", display:"flex", alignItems:"center", justifyContent:"center", zIndex:200, padding:20 }}>
      <div onClick={e=>e.stopPropagation()} style={{ backgroundColor:"#ffffff", borderRadius:16, padding:28, maxWidth:380, width:"100%", animation:"popIn 0.2s", boxShadow:"0 20px 60px rgba(0,0,0,0.4)", textAlign:"center" }}>
        <div style={{ fontFamily:"'Barlow Condensed', sans-serif", fontSize:22, fontWeight:800, color:"#1a1a2e", marginBottom:4 }}>CONFIRM PICK</div>
        <div style={{ fontSize:13, color:"#6b7280", fontFamily:"'Inter', sans-serif", marginBottom:20 }}>Week {week} selection</div>
        <div style={{ backgroundColor:"#f0fdf8", border:"1px solid #a7f3d0", borderRadius:12, padding:"20px 16px", marginBottom:20 }}>
          <TeamLogo name={team} size={64} style={{ margin:"0 auto 12px" }} />
          <div style={{ fontFamily:"'Barlow Condensed', sans-serif", fontSize:22, fontWeight:800, color:"#1a1a2e", marginBottom:4 }}>{team}</div>
          {opponent && (
            <div style={{ fontSize:13, color:"#374151", fontFamily:"'Inter', sans-serif" }}>
              vs {opponent} {spreadVal && <span style={{ fontWeight:600, color: spread < 0 ? "#dc2626" : "#3d9e7a" }}>({spreadVal})</span>}
            </div>
          )}
          <div style={{ fontSize:11, color:"#9ca3af", marginTop:8, fontFamily:"'Inter', sans-serif" }}>You can change this pick until games lock</div>
        </div>
        <div style={{ display:"flex", gap:10 }}>
          <button onClick={onConfirm} disabled={submitting} style={{ flex:1, padding:13, backgroundColor:"#3d9e7a", color:"#ffffff", border:"none", borderRadius:8, fontFamily:"'Inter', sans-serif", fontSize:15, fontWeight:600, cursor:"pointer" }}>
            {submitting ? "Locking in..." : "Lock it in"}
          </button>
          <button onClick={onCancel} style={{ flex:1, padding:13, backgroundColor:"transparent", color:"#6b7280", border:"1px solid #e5e7eb", borderRadius:8, cursor:"pointer", fontSize:14, fontFamily:"'Inter', sans-serif" }}>Cancel</button>
        </div>
      </div>
    </div>
  );
}

function SurvivorsGrid({ survivors, currentWeek, teamId, matchups }) {
  const weeks = Array.from({ length: currentWeek }, (_, i) => i + 1);
  const alive = survivors.filter(s => s.status === "alive");
  const eliminated = survivors.filter(s => s.status === "eliminated");
  const allSorted = [...alive, ...eliminated];

  // Has this pick's actual game kicked off yet? Defaults to "not started" (stays
  // locked) if we can't find the game — never leak a pick early on missing data.
  const pickGameStarted = (pick) => {
    if (!pick) return false;
    const game = matchups?.find(m => m.home_team === pick.nfl_team || m.away_team === pick.nfl_team);
    return game ? isGameLocked(game.commence_time) : false;
  };

  // Auto-scroll all the way right so current week is always the last visible column
  useEffect(() => {
    const el = document.getElementById('survivors-scroll');
    if (el) {
      setTimeout(() => { el.scrollLeft = el.scrollWidth; }, 150);
    }
  }, [currentWeek]);

  const PLAYER_W = 120;
  const WEEK_W = currentWeek <= 4 ? Math.floor((window.innerWidth - PLAYER_W - 56) / currentWeek) : 54;
  const TOTAL_W = 56;

  const PickBox = ({ pick, isCurrentLocked, isCurrent }) => {
    if (!pick) return (
      <div style={{ width:"100%", height:44, display:"flex", alignItems:"center", justifyContent:"center" }}>
        <span style={{ fontSize:12, color:"#d1d5db" }}>—</span>
      </div>
    );
    if (isCurrentLocked) return (
      <div style={{ width:"100%", height:44, display:"flex", alignItems:"center", justifyContent:"center" }}>
        <span style={{ fontSize:18 }}>🔒</span>
      </div>
    );
    const survived = pick.result === "survived";
    const elim = pick.result === "eliminated";
    return (
      <div>
        <div style={{ width:40, height:40, margin:"0 auto", borderRadius:6, backgroundColor: survived?"#f0fdf8":elim?"#fff5f5":"#fffbeb", border:`1.5px solid ${survived?"#a7f3d0":elim?"#fecaca":"#fcd34d"}`, display:"flex", alignItems:"center", justifyContent:"center", position:"relative", overflow:"hidden" }}>
          <TeamLogo name={pick.nfl_team} size={34} />
          {survived && <div style={{ position:"absolute", bottom:1, right:1, fontSize:7, color:"#3d9e7a", fontWeight:900 }}>✓</div>}
          {elim && <div style={{ position:"absolute", bottom:1, right:1, fontSize:7, color:"#dc2626", fontWeight:900 }}>✗</div>}
        </div>
        <div style={{ fontSize:8, color:"#9ca3af", marginTop:2, textAlign:"center", fontFamily:"'Inter', sans-serif" }}>{getShort(pick.nfl_team)}</div>
      </div>
    );
  };

  return (
    <div>
      <div id="survivors-scroll" style={{ overflowX:"auto", WebkitOverflowScrolling:"touch", width:"100%" }}>
        <table style={{ borderCollapse:"separate", borderSpacing:"0 6px", width:"100%" }}>

          <thead>
            <tr>
              <th style={{ padding:"6px 10px", textAlign:"left", fontSize:11, fontWeight:600, color:"#9ca3af", fontFamily:"'Inter', sans-serif", letterSpacing:"0.05em", position:"sticky", left:0, backgroundColor:"#0a0e1a", zIndex:10 }}>PLAYER</th>
              {weeks.map(w => (
                <th key={w} style={{ padding:"6px 2px", textAlign:"center", fontSize:10, fontWeight:600, color: w === currentWeek ? "#3d9e7a" : "#6b7280", fontFamily:"'Inter', sans-serif", letterSpacing:"0.04em" }}>
                  {w === currentWeek ? <span style={{ color:"#3d9e7a" }}>W{w} ◀</span> : `W${w}`}
                </th>
              ))}
              <th style={{ padding:"6px 6px", textAlign:"center", fontSize:9, fontWeight:600, color:"#6b7280", fontFamily:"'Inter', sans-serif", whiteSpace:"nowrap", position:"sticky", right:0, backgroundColor:"#0a0e1a", zIndex:10 }}>TOTAL WKS</th>
            </tr>
          </thead>
          <tbody>
            {allSorted.map((survivor) => {
              const isMe = survivor.id === teamId;
              const isEliminated = survivor.status === "eliminated";
              return (
                <tr key={survivor.id} style={{ opacity: isEliminated ? 0.5 : 1 }}>
                  {/* Sticky player name */}
                  <td style={{
                    padding:"8px 10px",
                    position:"sticky", left:0, zIndex:5,
                    backgroundColor: isMe ? "#f0fdf8" : "#ffffff",
                    borderRadius:"8px 0 0 8px",
                    border: isMe ? "1.5px solid #a7f3d0" : "1px solid #f3f4f6",
                    borderRight:"none",
                    boxShadow:"4px 0 8px rgba(0,0,0,0.15)",
                  }}>
                    <div style={{ fontFamily:"'Inter', sans-serif", fontSize:12, fontWeight:700, color: isEliminated ? "#9ca3af" : "#1a1a2e", overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>
                      {survivor.team_name}
                      {isMe && <span style={{ marginLeft:4, fontSize:8, color:"#3d9e7a", fontWeight:700, backgroundColor:"#f0fdf8", border:"1px solid #a7f3d0", borderRadius:3, padding:"1px 4px" }}>YOU</span>}
                    </div>
                    <div style={{ fontSize:10, color:"#9ca3af", fontFamily:"'Inter', sans-serif" }}>{survivor.owner_name}</div>
                  </td>

                  {/* Week picks */}
                  {weeks.map(w => {
                    const pick = survivor.picks?.find(p => p.week === w);
                    const isCurrentLocked = w === currentWeek && survivor.id !== teamId && pick && !pickGameStarted(pick);
                    const isCurrent = w === currentWeek;
                    return (
                      <td key={w} style={{
                        padding:"4px 2px", textAlign:"center",
                        backgroundColor: isMe ? "#f0fdf8" : "#ffffff",
                        border: isMe ? "1.5px solid #a7f3d0" : "1px solid #f3f4f6",
                        borderLeft: isCurrent ? "2px solid #3d9e7a" : (isMe ? "1.5px solid #a7f3d0" : "1px solid #f3f4f6"),
                        borderRight:"none",
                      }}>
                        <PickBox pick={pick} isCurrentLocked={isCurrentLocked} isCurrent={isCurrent}/>
                      </td>
                    );
                  })}

                  {/* Total - sticky right */}
                  <td style={{
                    padding:"8px 6px", textAlign:"center",
                    position:"sticky", right:0, zIndex:5,
                    backgroundColor: isMe ? "#f0fdf8" : "#ffffff",
                    border: isMe ? "1.5px solid #a7f3d0" : "1px solid #f3f4f6",
                    borderLeft:"none",
                    borderRadius:"0 8px 8px 0",
                    boxShadow:"-4px 0 8px rgba(0,0,0,0.12)",
                  }}>
                    <div style={{ fontFamily:"'Barlow Condensed', sans-serif", fontSize:15, fontWeight:800, color: isEliminated ? "#dc2626" : "#3d9e7a" }}>
                      {isEliminated ? `W${survivor.eliminated_week}` : survivor.weeks_survived}
                    </div>
                    <div style={{ fontSize:8, color:"#9ca3af", fontFamily:"'Inter', sans-serif" }}>{isEliminated ? "out" : "wks"}</div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      {currentWeek > 1 && <div style={{ textAlign:"center", fontSize:10, color:"#6b7280", fontFamily:"'Inter', sans-serif", paddingTop:6 }}>← swipe to see earlier weeks</div>}
    </div>
  );
}

function AdminBanner({ leagueId, isMobile }) {
  const key = `scraps_admin_seen_${leagueId}`;
  const [seen, setSeen] = useState(()=>!!localStorage.getItem(key));
  if (seen) return null;
  return (
    <div style={{background:"#1e3a5f",borderBottom:"2px solid #3b82f6",padding:"10px 16px",display:"flex",alignItems:"center",justifyContent:"space-between",gap:12,flexShrink:0}}>
      <div style={{display:"flex",alignItems:"center",gap:10,flex:1,minWidth:0}}>
        <span style={{fontSize:isMobile?16:18,flexShrink:0}}>⚙️</span>
        <span style={{fontSize:isMobile?12:13,color:"#bfdbfe",fontFamily:"'Inter',sans-serif",lineHeight:1.4}}>
          <strong style={{color:"#ffffff"}}>You're the league admin.</strong>{" "}
          {isMobile ? "Tap Admin in the nav below to manage your league." : "Tap ⚙️ next to the league name to manage settings, members and more."}
        </span>
      </div>
      <button onClick={()=>{localStorage.setItem(key,"1");setSeen(true);}} style={{background:"rgba(255,255,255,0.15)",border:"1px solid rgba(255,255,255,0.2)",borderRadius:6,color:"#ffffff",cursor:"pointer",fontSize:12,fontWeight:600,padding:"5px 12px",fontFamily:"'Inter',sans-serif",flexShrink:0,whiteSpace:"nowrap"}}>
        Got it
      </button>
    </div>
  );
}

export default function Eliminator({ teamId, leagueId, teamName, isAdmin, onAdminClick, onBack, leagueName, token }) {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  const [activeTab, setActiveTab] = useState("survivors");
  const [usedTeams, setUsedTeams] = useState([]);
  const [myPicks, setMyPicks] = useState([]);
  const [settings, setSettings] = useState(null);
  const [survivors, setSurvivors] = useState([]);
  const [matchups, setMatchups] = useState([]);
  const [confirmTeam, setConfirmTeam] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [currentPick, setCurrentPick] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => { loadAll(); }, []);

  const loadAll = async () => {
    setLoading(true);
    try {
      const [picksRes, settingsRes, survivorsRes, matchupsRes] = await Promise.all([
        fetch(`${API}/eliminator/${leagueId}/my-picks/${teamId}`),
        fetch(`${API}/eliminator/${leagueId}/settings`),
        fetch(`${API}/eliminator/${leagueId}/survivors`),
        fetch(`${API}/eliminator/nfl-matchups`),
      ]);
      const picks = await picksRes.json();
      const s = await settingsRes.json();
      const surv = await survivorsRes.json();
      const m = await matchupsRes.json();
      setUsedTeams(picks.used_teams || []);
      setMyPicks(picks.picks || []);
      setSettings(s);
      setSurvivors(surv);
      setMatchups(Array.isArray(m) ? m : []);
      const thisPick = picks.picks?.find(p => p.week === s.current_week);
      setCurrentPick(thisPick || null);
    } catch(e) { console.error(e); }
    setLoading(false);
  };

  const getMatchup = (teamName) => {
    const game = matchups.find(m => m.home_team === teamName || m.away_team === teamName);
    if (!game) return null;
    const opponent = game.home_team === teamName ? game.away_team : game.home_team;
    const spread = game.spread?.[teamName];
    return { opponent, spread, commenceTime: game.commence_time, locked: isGameLocked(game.commence_time) };
  };

  const submitPick = async (team) => {
    setSubmitting(true);
    try {
      const res = await fetch(`${API}/eliminator/${leagueId}/pick`, {
        method:"POST", headers:{"Content-Type":"application/json"},
        body:JSON.stringify({ team_id:teamId, nfl_team:team }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.detail);
      setCurrentPick(data.pick);
      setConfirmTeam(null);
      await loadAll();
      setActiveTab("survivors");
    } catch(e) { alert("Error: " + e.message); }
    setSubmitting(false);
  };

  const myStatus = survivors.find(s => s.id === teamId);
  const isEliminated = myStatus?.status === "eliminated";
  const aliveCount = survivors.filter(s => s.status === "alive").length;

  if (loading) return (
    <div style={{ minHeight:"100vh", backgroundColor:"#0a0e1a", display:"flex", alignItems:"center", justifyContent:"center" }}>
      <style>{FONT}{CSS}</style>
      <div style={{ textAlign:"center", color:"#6b7280" }}>
        <div style={{ fontSize:28, animation:"pulse 1.2s infinite", marginBottom:12 }}>⟳</div>
        <div style={{ fontFamily:"'Inter', sans-serif", fontSize:13 }}>Loading...</div>
      </div>
    </div>
  );

  return (
    <div style={{ height:"100vh", overflow:"hidden", backgroundColor:"#0a0e1a", fontFamily:"'Inter', sans-serif", display:"flex", flexDirection:"column" }}>
      <style>{FONT}{CSS}</style>

      {confirmTeam && (
        <ConfirmPickModal
          team={confirmTeam}
          week={settings?.current_week}
          opponent={getMatchup(confirmTeam)?.opponent}
          spread={getMatchup(confirmTeam)?.spread}
          onConfirm={() => submitPick(confirmTeam)}
          onCancel={() => setConfirmTeam(null)}
          submitting={submitting}
        />
      )}

      {/* Top bar */}
      <div style={{ backgroundColor:"#111827", borderBottom:"1px solid rgba(255,255,255,0.07)", padding:isMobile?"10px 14px":"12px 20px", display:"flex", alignItems:"center", justifyContent:"space-between" }}>
        <div style={{ display:"flex", alignItems:"center", gap:isMobile?10:16, minWidth:0 }}>
          <button onClick={onBack} style={{ background:"none", border:"none", color:"#ffffff", cursor:"pointer", fontSize:isMobile?26:13, fontFamily:"'Inter', sans-serif", flexShrink:0, padding:0, lineHeight:1, fontWeight:900 }}>
            {isMobile ? "≡" : "≡ My Leagues"}
          </button>
          {!isMobile && <div style={{ width:1, height:20, backgroundColor:"rgba(255,255,255,0.1)" }}/>}
          <div style={{ display:"flex", alignItems:"center", gap:8, minWidth:0 }}>
            <div style={{ fontFamily:"'Barlow Condensed', sans-serif", fontSize:isMobile?20:18, fontWeight:800, color:"#f0f4ff", overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>{leagueName}</div>
            {isAdmin && !isMobile && <button onClick={onAdminClick} style={{ background:"rgba(255,255,255,0.08)", border:"1px solid rgba(255,255,255,0.15)", borderRadius:6, padding:"3px 8px", cursor:"pointer", fontSize:14, color:"#9ca3af", flexShrink:0 }} title="League Admin">⚙️</button>}
          </div>
        </div>
        <div style={{ flexShrink:0, display:"flex", alignItems:"center", gap:8 }}>
          <div style={{ backgroundColor: isEliminated ? "rgba(220,38,38,0.2)" : "rgba(61,158,122,0.2)", border: isEliminated ? "1.5px solid #ff4d6d" : "1.5px solid #3d9e7a", borderRadius:10, padding:isMobile?"6px 12px":"6px 14px" }}>
            <div style={{ fontFamily:"'Barlow Condensed', sans-serif", fontSize:isMobile?16:20, fontWeight:800, color: isEliminated ? "#ff4d6d" : "#ffffff", lineHeight:1, textAlign:"center" }}>
              {isEliminated ? "✗ OUT" : "✓ ALIVE"}
            </div>
          </div>
        </div>
      </div>

      {/* Week banner */}
      <div style={{ backgroundColor:"#0f172a", borderBottom:"1px solid rgba(255,255,255,0.06)", padding:isMobile?"10px 14px":"12px 20px", display:"grid", gridTemplateColumns:currentPick?"1fr 1fr 1fr":"1fr 1fr", gap:10 }}>
        <div style={{ backgroundColor:"rgba(220,38,38,0.1)", border:"1px solid rgba(220,38,38,0.2)", borderRadius:10, padding:"10px 14px", textAlign:"center" }}>
          <div style={{ fontSize:10, fontWeight:600, color:"#9ca3af", fontFamily:"'Inter', sans-serif", letterSpacing:"0.06em", marginBottom:2 }}>CURRENT WEEK</div>
          <div style={{ fontFamily:"'Barlow Condensed', sans-serif", fontSize:isMobile?24:26, fontWeight:800, color:"#f0f4ff" }}>{settings?.current_week}</div>
        </div>
        <div style={{ backgroundColor:"rgba(61,158,122,0.1)", border:"1px solid rgba(61,158,122,0.2)", borderRadius:10, padding:"10px 14px", textAlign:"center" }}>
          <div style={{ fontSize:10, fontWeight:600, color:"#9ca3af", fontFamily:"'Inter', sans-serif", letterSpacing:"0.06em", marginBottom:2 }}>SURVIVORS</div>
          <div style={{ fontFamily:"'Barlow Condensed', sans-serif", fontSize:isMobile?24:26, fontWeight:800, color:"#3d9e7a" }}>{aliveCount} <span style={{ fontSize:13, color:"#6b7280", fontWeight:400 }}>/ {survivors.length}</span></div>
        </div>
        {currentPick && (
          <div style={{ backgroundColor:"rgba(245,183,49,0.1)", border:"1px solid rgba(245,183,49,0.2)", borderRadius:10, padding:"10px 14px", textAlign:"center" }}>
            <div style={{ fontSize:10, fontWeight:600, color:"#9ca3af", fontFamily:"'Inter', sans-serif", letterSpacing:"0.06em", marginBottom:4 }}>YOUR PICK</div>
            <div style={{ display:"flex", alignItems:"center", justifyContent:"center", gap:6 }}>
              <TeamLogo name={currentPick.nfl_team} size={isMobile?22:24} />
              <div style={{ fontFamily:"'Barlow Condensed', sans-serif", fontSize:isMobile?20:22, fontWeight:800, color:"#f5b731" }}>{getShort(currentPick.nfl_team)}</div>
            </div>
          </div>
        )}
      </div>

      {/* Nav tabs */}
      <div style={{ backgroundColor:"#111827", borderBottom:"1px solid rgba(255,255,255,0.07)", padding:isMobile?"0":"0 20px", display:"flex", justifyContent:"center" }}>
        {[
          { key:"survivors", label:"Survivors", icon:"🏆" },
          { key:"pick", label:"Make Pick", icon:"🏈" },
          { key:"history", label:"My Picks", icon:"📋" },
          ...(isAdmin ? [{ key:"admin", label:"Admin", icon:"⚙️" }] : []),
        ].map(tab => (
          <button key={tab.key} onClick={() => { if(tab.key==="admin") { onAdminClick(); } else { setActiveTab(tab.key); } }} style={{
            flex:isMobile?1:undefined,
            padding:isMobile?"10px 4px":"14px 28px", border:"none", backgroundColor:"transparent", cursor:"pointer",
            color: activeTab===tab.key ? "#f0f4ff" : "#6b7280",
            borderBottom: activeTab===tab.key ? "3px solid #dc2626" : "3px solid transparent",
            fontFamily:"'Inter', sans-serif", fontSize:isMobile?11:15, fontWeight: activeTab===tab.key ? 700 : 400,
            whiteSpace:"nowrap", display:"flex", flexDirection:isMobile?"column":"row", alignItems:"center", gap:isMobile?2:8,
          }}>
            <span style={{ fontSize:isMobile?18:16 }}>{tab.icon}</span>
            <span>{tab.label}</span>
          </button>
        ))}
      </div>

      <div style={{ flex:1, overflowY:"auto", padding:isMobile?12:16, maxWidth:1100, margin:"0 auto", width:"100%" }}>

        {/* SURVIVORS TAB */}
        {activeTab === "survivors" && (
          <div>
            <div style={{ fontSize:12, color:"#f0f4ff", fontFamily:"'Inter', sans-serif", marginBottom:14, padding:"10px 14px", backgroundColor:"rgba(255,255,255,0.06)", borderRadius:8, border:"1px solid rgba(255,255,255,0.1)", display:"flex", gap:16, flexWrap:"wrap" }}>
              <span>🔒 Pick hidden until kickoff</span>
              <span style={{color:"#3d9e7a"}}>✓ Survived</span>
              <span style={{color:"#dc2626"}}>✗ Eliminated</span>
            </div>
            <SurvivorsGrid survivors={survivors} currentWeek={settings?.current_week || 1} teamId={teamId} matchups={matchups} />
          </div>
        )}

        {/* MAKE PICK TAB */}
        {activeTab === "pick" && (
          <div>
            {isEliminated ? (
              <div style={{ textAlign:"center", padding:"48px 24px", backgroundColor:"#ffffff", borderRadius:16, border:"1px solid #fecaca", boxShadow:"0 1px 4px rgba(0,0,0,0.06)" }}>
                <div style={{ fontSize:48, marginBottom:16 }}>💀</div>
                <div style={{ fontFamily:"'Barlow Condensed', sans-serif", fontSize:28, fontWeight:800, color:"#dc2626", marginBottom:8 }}>ELIMINATED</div>
                <div style={{ fontSize:14, color:"#6b7280", fontFamily:"'Inter', sans-serif" }}>You were eliminated in Week {myStatus?.eliminated_week}. Better luck next season!</div>
              </div>
            ) : (
              <>
                {currentPick && (
                  <div style={{ backgroundColor:"#f0fdf8", border:"1.5px solid #a7f3d0", borderRadius:12, padding:"14px 18px", marginBottom:16, display:"flex", alignItems:"center", gap:14, animation:"fadeIn 0.3s" }}>
                    <TeamLogo name={currentPick.nfl_team} size={44} />
                    <div style={{ flex:1 }}>
                      <div style={{ fontFamily:"'Inter', sans-serif", fontSize:13, fontWeight:600, color:"#3d9e7a", marginBottom:2 }}>Week {settings?.current_week} pick locked in</div>
                      <div style={{ fontSize:16, color:"#1a1a2e", fontWeight:700, fontFamily:"'Inter', sans-serif" }}>{currentPick.nfl_team}</div>
                      <div style={{ fontSize:12, color:"#6b7280", marginTop:2, fontFamily:"'Inter', sans-serif" }}>You can change until games lock</div>
                    </div>
                    <span style={{ fontSize:11, padding:"3px 10px", borderRadius:20, backgroundColor:"#fffbeb", color:"#92400e", border:"1px solid #fcd34d", fontFamily:"'Inter', sans-serif", fontWeight:600 }}>Pending</span>
                  </div>
                )}

                <div style={{ fontSize:12, fontWeight:600, color:"#6b7280", letterSpacing:"0.06em", marginBottom:14, fontFamily:"'Inter', sans-serif" }}>
                  {currentPick ? "CHANGE YOUR PICK" : `SELECT WEEK ${settings?.current_week} TEAM`}
                </div>

                <div style={{ display:"grid", gridTemplateColumns:isMobile?"repeat(3, 1fr)":"repeat(auto-fill, minmax(140px, 1fr))", gap:isMobile?8:10 }}>
                  {NFL_TEAMS.map(team => {
                    const isUsed = usedTeams.includes(team.name) && team.name !== currentPick?.nfl_team;
                    const isCurrent = currentPick?.nfl_team === team.name;
                    const matchup = getMatchup(team.name);
                    const spread = matchup?.spread;
                    const spreadStr = spread !== undefined ? (spread > 0 ? `+${spread}` : `${spread}`) : null;
                    const gameLocked = matchup?.locked && !isCurrent;
                    const gameTime = matchup ? formatGameTime(matchup.commenceTime) : null;
                    const isDisabled = isUsed || gameLocked;

                    return (
                      <button
                        key={team.name}
                        className={isDisabled ? "" : "team-card"}
                        onClick={() => !isDisabled && setConfirmTeam(team.name)}
                        disabled={isDisabled}
                        style={{
                          padding:"12px 10px",
                          backgroundColor: isCurrent ? "#f0fdf8" : gameLocked ? "#f9fafb" : isUsed ? "#f9fafb" : "#ffffff",
                          border: isCurrent ? "1.5px solid #3d9e7a" : gameLocked ? "1px solid #f3f4f6" : isUsed ? "1px solid #f3f4f6" : "1px solid #e5e7eb",
                          borderRadius:12, cursor: isDisabled ? "not-allowed" : "pointer",
                          textAlign:"center", opacity: isUsed ? 0.35 : gameLocked ? 0.5 : 1,
                          boxShadow: isDisabled ? "none" : "0 1px 3px rgba(0,0,0,0.06)",
                        }}
                      >
                        <TeamLogo name={team.name} size={40} style={{ margin:"0 auto 8px" }} />
                        <div style={{ fontSize:12, fontWeight:700, color: isCurrent ? "#3d9e7a" : isDisabled ? "#9ca3af" : "#1a1a2e", fontFamily:"'Inter', sans-serif", marginBottom:2 }}>
                          {team.short}
                        </div>
                        {matchup && !isUsed && !gameLocked && (
                          <div style={{ fontSize:10, color:"#6b7280", fontFamily:"'Inter', sans-serif", marginBottom:2 }}>
                            vs {getShort(matchup.opponent)}
                            {spreadStr && <span style={{ marginLeft:3, color: spread < 0 ? "#dc2626" : "#3d9e7a", fontWeight:600 }}>{spreadStr}</span>}
                          </div>
                        )}
                        {gameTime && !isUsed && !gameLocked && (
                          <div style={{ fontSize:9, color:"#9ca3af", fontFamily:"'Inter', sans-serif" }}>{gameTime}</div>
                        )}
                        {gameLocked && !isCurrent && <div style={{ fontSize:9, color:"#9ca3af", fontFamily:"'Inter', sans-serif" }}>🔒 In progress</div>}
                        {isUsed && <div style={{ fontSize:9, color:"#9ca3af", fontFamily:"'Inter', sans-serif" }}>Used</div>}
                        {isCurrent && <div style={{ fontSize:9, color:"#3d9e7a", fontFamily:"'Inter', sans-serif", fontWeight:600 }}>✓ Picked</div>}
                      </button>
                    );
                  })}
                </div>
              </>
            )}
          </div>
        )}

        {/* MY PICKS TAB */}
        {activeTab === "history" && (
          <div>
            {/* Current week pick */}
            {currentPick && (
              <div style={{ marginBottom:20 }}>
                <div style={{ display:"flex", alignItems:"center", gap:10, marginBottom:12, padding:"12px 16px", backgroundColor:"#fffbeb", border:"1px solid #fcd34d", borderRadius:10 }}>
                  <div style={{ fontFamily:"'Barlow Condensed', sans-serif", fontSize:16, fontWeight:800, color:"#92400e" }}>⏳ CURRENT WEEK</div>
                  <span style={{ backgroundColor:"#fcd34d", color:"#92400e", fontSize:11, fontWeight:700, padding:"2px 8px", borderRadius:20, fontFamily:"'Inter', sans-serif" }}>Week {currentPick.week}</span>
                </div>
                <div style={{ backgroundColor:"#ffffff", border:"1.5px solid #a7f3d0", borderRadius:12, padding:"14px 18px", display:"flex", alignItems:"center", gap:14, boxShadow:"0 1px 3px rgba(0,0,0,0.06)" }}>
                  <TeamLogo name={currentPick.nfl_team} size={48} />
                  <div style={{ flex:1 }}>
                    <div style={{ fontFamily:"'Inter', sans-serif", fontSize:16, fontWeight:700, color:"#1a1a2e" }}>{currentPick.nfl_team}</div>
                    {getMatchup(currentPick.nfl_team) && (
                      <div style={{ fontSize:12, color:"#6b7280", fontFamily:"'Inter', sans-serif", marginTop:2 }}>vs {getMatchup(currentPick.nfl_team)?.opponent}</div>
                    )}
                  </div>
                  <span style={{ fontSize:11, padding:"3px 10px", borderRadius:20, backgroundColor:"#fffbeb", color:"#92400e", border:"1px solid #fcd34d", fontFamily:"'Inter', sans-serif", fontWeight:600 }}>Pending</span>
                </div>
              </div>
            )}

            {/* Past picks */}
            <div style={{ display:"flex", alignItems:"center", gap:10, marginBottom:12, padding:"12px 16px", backgroundColor:"#f3f4f6", border:"1px solid #e5e7eb", borderRadius:10 }}>
              <div style={{ fontFamily:"'Inter', sans-serif", fontSize:16, fontWeight:700, color:"#374151" }}>📋 Pick History</div>
              <span style={{ backgroundColor:"#e5e7eb", color:"#374151", fontSize:11, fontWeight:700, padding:"2px 8px", borderRadius:20, fontFamily:"'Inter', sans-serif" }}>{myPicks.filter(p=>p.result!=="pending").length}</span>
            </div>

            {myPicks.filter(p => p.result !== "pending").length === 0 ? (
              <div style={{ textAlign:"center", padding:40, backgroundColor:"#ffffff", borderRadius:12, border:"1px solid #f3f4f6", color:"#9ca3af", fontSize:13, fontFamily:"'Inter', sans-serif" }}>No settled picks yet</div>
            ) : [...myPicks].filter(p => p.result !== "pending").reverse().map(pick => (
              <div key={pick.id} style={{ backgroundColor:"#ffffff", border:"1px solid #f3f4f6", borderRadius:12, padding:"14px 16px", marginBottom:8, display:"flex", alignItems:"center", gap:14, boxShadow:"0 1px 3px rgba(0,0,0,0.06)" }}>
                <TeamLogo name={pick.nfl_team} size={44} />
                <div style={{ flex:1 }}>
                  <div style={{ fontFamily:"'Inter', sans-serif", fontSize:14, fontWeight:700, color:"#1a1a2e", marginBottom:2 }}>Week {pick.week}</div>
                  <div style={{ fontSize:13, color:"#374151", fontFamily:"'Inter', sans-serif" }}>{pick.nfl_team}</div>
                </div>
                <span style={{ fontSize:11, padding:"3px 10px", borderRadius:20, fontFamily:"'Inter', sans-serif", fontWeight:600,
                  backgroundColor: pick.result==="survived" ? "#f0fdf8" : "#fff5f5",
                  color: pick.result==="survived" ? "#065f46" : "#dc2626",
                  border: pick.result==="survived" ? "1px solid #a7f3d0" : "1px solid #fecaca",
                }}>
                  {pick.result === "survived" ? "✓ Survived" : "✗ Eliminated"}
                </span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
